export enum NotifyActionType {
  downloadIpa = 'download_ipa',
  distributionLeave = 'distribution_leave',
}
